"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkXS = exports.LinkS = exports.LinkM = exports.LinkL = exports.LinkXL = exports.getLinkExtraSmallStyles = exports.getLinkSmallStyles = exports.getLinkMediumStyles = exports.getLinkLargeStyles = exports.getLinkExtraLargeStyles = exports.Link = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Color_enum_1 = require("../../constants/Color.enum");
var Link;
(function (Link) {
    Link["ExtraLarge"] = "x-large";
    Link["Large"] = "large";
    Link["Medium"] = "medium";
    Link["Small"] = "small";
    Link["ExtraSmall"] = "x-small";
})(Link = exports.Link || (exports.Link = {}));
const getLinkExtraLargeStyles = (props) => ({
    fontSize: '1.5rem',
    fontWeight: props.fontWeight || 500,
    lineHeight: '2.125rem',
    letterSpacing: '0.047rem',
});
exports.getLinkExtraLargeStyles = getLinkExtraLargeStyles;
const getLinkLargeStyles = (props) => ({
    fontSize: '1.25rem',
    fontWeight: props.fontWeight || 500,
    lineHeight: '2rem',
    letterSpacing: '0.047rem',
});
exports.getLinkLargeStyles = getLinkLargeStyles;
const getLinkMediumStyles = (props) => ({
    fontSize: '1.125rem',
    fontWeight: props.fontWeight || 500,
    lineHeight: '1.875rem',
    letterSpacing: '0.047rem',
});
exports.getLinkMediumStyles = getLinkMediumStyles;
const getLinkSmallStyles = (props) => ({
    fontSize: '1rem',
    fontWeight: props.fontWeight || 500,
    lineHeight: '1.5rem',
    letterSpacing: ' 0.047rem',
});
exports.getLinkSmallStyles = getLinkSmallStyles;
const getLinkExtraSmallStyles = (props) => ({
    fontSize: '0.875rem',
    fontWeight: props.fontWeight || 500,
    lineHeight: '1.25rem',
    letterSpacing: ' 0.047rem',
});
exports.getLinkExtraSmallStyles = getLinkExtraSmallStyles;
const variantMap = {
    [Link.ExtraLarge]: exports.getLinkExtraLargeStyles,
    [Link.Large]: exports.getLinkLargeStyles,
    [Link.Medium]: exports.getLinkMediumStyles,
    [Link.Small]: exports.getLinkSmallStyles,
    [Link.ExtraSmall]: exports.getLinkExtraSmallStyles,
};
const getStylesByType = (type = Link.Large, props) => { var _a; return ((_a = (type ? variantMap[type] : undefined)) !== null && _a !== void 0 ? _a : exports.getLinkMediumStyles)(props); };
const BaseComponent = styled_components_1.default.div `
    ${(props) => getStylesByType(props.type, props)}
    color: ${(props) => props.color || Color_enum_1.Color.Primary};
`;
const createLinkComponent = (type) => 
// eslint-disable-next-line react/display-name
(_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    return react_1.default.createElement(BaseComponent, Object.assign({ type: type, color: color }, props));
};
exports.LinkXL = createLinkComponent(Link.ExtraLarge);
exports.LinkL = createLinkComponent(Link.Large);
exports.LinkM = createLinkComponent(Link.Medium);
exports.LinkS = createLinkComponent(Link.Small);
exports.LinkXS = createLinkComponent(Link.ExtraSmall);
